<template>

    <div class="bg-white rounded-lg w-full max-w-4xl max-h-128 px-6 py-10 md:p-12 items-center relative">
        <p v-if="errorMessageModal" class="alert-error items-center mb-4">
            <i class="fa-solid fa-triangle-exclamation text-alert"></i>
            {{ errorMessageModal }}
            <button
                type="button"
                class="alert-close link-styles--gray"
                @click="clearErrorMessageModal"
            >
                <i class="fa-light fa-xmark w-6 h-6" title="Close"></i>
            </button>
        </p>

        <div class="pb-4">
            <h2 class="text-lg font-bold text-center">
                以下のメンバーを削除します。よろしいですか？
            </h2>
        </div>

        <!-- メンバー情報出力画面 -->
        <div class="self-stretch pt-4 pb-4 bg-slate-50 rounded flex flex-col justify-start items-center gap-2">
            <div class="w-[178px] px-3 flex justify-start items-center gap-2">
                <div class="shrink-0 w-8 h-8 rounded-full overflow-hidden">
                    <img v-if="image_url != null"
                        :src="image_url"
                        alt="Avatar"
                        class="w-full h-full object-cover"
                    />
                    <div v-else
                         class="w-full h-full object-cover bg-gray-100 rounded-full flex justify-center items-center shrink-0 mx-auto border border-gray-200 border-solid border-[1px]">
                        <i class="fa-solid fa-user text-xl text-gray-500"></i>
                    </div>
                </div>
                <div class="text-gray-600 text-base font-light leading-6 break-words">
                    {{ props.name }}
                </div>
            </div>
            <div class="self-stretch px-3 flex justify-center items-center gap-2">
                <div class="flex-1 flex flex-wrap items-center gap-3">
                    <div class="flex-1 text-center text-gray-600 text-base font-semibold leading-6 break-words">
                        {{ props.email }}
                    </div>
                </div>
            </div>
        </div>

        <!-- ボタン群 -->
        <div class="flex justify-center items-start gap-2 mt-8">
            <button
                data-propaty="secondary"
                data-status="default"
                class="btn-secondary"
                @click="$emit('close-modal')"
            >
                キャンセル
            </button>
            <button
                class="text-white text-base font-semibold px-4 py-2 bg-red-600 hover:bg-red-700 rounded flex justify-center items-center"
                @click="deleteInvitation"
            >
                削除申請する
            </button>
        </div>
    </div>
</template>




<script setup>
import { defineProps, defineEmits } from "vue";
import axios from "axios";
import { useStore } from "vuex";

const emit = defineEmits(["close-modal", "load-member"]);

const props = defineProps({
    name: String,
    email: String,
    id: Number,
    image_url: String,
});

const store = useStore();
const accessToken = store.state.accessToken;
const apiEndpoint = process.env.VUE_APP_API_ENDPOINT;

const deleteInvitation = async () => {
    try {
        const response = await axios.delete(
            `${apiEndpoint}/member-invitations/${props.id}`,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
        if (response.status == 204) {
            console.log("招待を削除しました");
            emit("load-member");
            emit("close-modal");
        }
    } catch (error) {
        console.error("招待の削除に失敗しました", error);
    }
};
</script>
